import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=273c6a5f&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=273c6a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c6a5f",
  null
  
)

export default component.exports